import {DateFormatEnum} from 'presentation/constants';
import {FlowTypeEnum, formatDateString} from 'presentation/utils';
import {formatUtcDate} from 'presentation/utils/convertDate';
import extractTimeFromUTC from 'presentation/utils/extractTimeFromUTC';
import {FlowEnum} from '../constants';

const getFormattedHour = (hour: string, flowType: FlowTypeEnum): string => {
	if (!hour) return '';

	if (flowType === FlowEnum.TELEHEALTH && hour.includes('T')) {
		return formatDateString(formatUtcDate(hour), DateFormatEnum.DATE_FORMAT_9, 'HH:mm');
	}

	if (flowType === FlowEnum.HEALTH && hour.includes('T')) {
		return extractTimeFromUTC(hour);
	}

	return hour;
};

export default getFormattedHour;
